import React from "react";
import { MapPin, Phone, Mail, Facebook, ExternalLink } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1C3A27] text-white" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Contenu principal du footer */}
        <div className="py-12 md:py-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Informations du gîte */}
            <div className="lg:col-span-2">
              <h3 className="font-serif text-2xl font-bold mb-4">
                Cœurs de Normands
              </h3>
              <p className="text-white/80 mb-6 leading-relaxed">
                Gîte de charme en Suisse Normande, jusqu'à 10 personnes. 
                Découvrez un hébergement authentique et chaleureux au cœur de la nature normande.
              </p>
              <div className="flex items-center text-sm text-white/70 mb-2">
                <span className="font-medium">Clévacances – 3 clés</span>
              </div>
              <div className="text-sm text-white/70">
                Nathalie & Wilhelm Martel, propriétaires
              </div>
            </div>

            {/* Contact rapide */}
            <div>
              <h4 className="font-semibold text-lg mb-4">Contact</h4>
              <div className="space-y-3">
                <div className="flex items-start">
                  <MapPin size={16} className="mr-2 mt-0.5 flex-shrink-0 text-white/70" />
                  <span className="text-sm text-white/80">
                    31 Rue Notre-Dame<br />
                    14570 Clécy, France
                  </span>
                </div>
                <a
                  href="mailto:wilhelm.martel@orange.fr"
                  className="flex items-center text-sm text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#1C3A27] rounded-sm"
                  aria-label="Envoyer un email à wilhelm.martel@orange.fr"
                >
                  <Mail size={16} className="mr-2 flex-shrink-0" />
                  wilhelm.martel@orange.fr
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=100089881764871"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-sm text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#1C3A27] rounded-sm"
                  aria-label="Suivre sur Facebook - Ouverture dans un nouvel onglet"
                  title="Page Facebook de Cœurs de Normands"
                >
                  <Facebook size={16} className="mr-2 flex-shrink-0" />
                  Facebook
                </a>
              </div>
            </div>

            {/* Réservations */}
            <div>
              <h4 className="font-semibold text-lg mb-4">Réservations</h4>
              <div className="space-y-3">
                <a
                  href="https://www.airbnb.fr/rooms/1124426465764074190"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-sm text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#1C3A27] rounded-sm"
                  aria-label="Réserver sur Airbnb - Ouverture dans un nouvel onglet"
                  title="Réservez directement sur Airbnb"
                >
                  <ExternalLink size={16} className="mr-2 flex-shrink-0" />
                  Airbnb
                </a>
                <a
                  href="https://www.booking.com/hotel/fr/gite-au-coeur-de-la-suisse-normande.fr.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-sm text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#1C3A27] rounded-sm"
                  aria-label="Réserver sur Booking.com - Ouverture dans un nouvel onglet"
                  title="Réservez directement sur Booking.com"
                >
                  <ExternalLink size={16} className="mr-2 flex-shrink-0" />
                  Booking.com
                </a>
                <div className="text-sm text-white/70 mt-4">
                  Ou contactez-nous directement pour une réservation personnalisée
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Ligne de séparation */}
        <div className="border-t border-white/20"></div>

        {/* Bas de page avec mentions légales et signature VibeSite */}
        <div className="py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Mentions légales */}
            <div className="text-sm text-white/70 text-center md:text-left">
              <p>© {currentYear} Cœurs de Normands. Tous droits réservés.</p>
              <p className="mt-1">
                Gîte de charme • Clécy, Suisse Normande • Clévacances 3 clés
              </p>
            </div>

            {/* Signature VibeSite - mise à jour selon les spécifications */}
            <div className="text-center">
              <p className="text-xs text-white/50">
                Site réalisé par{" "}
                <a
                  href="https://vibesite.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Création de sites pour hébergements d'exception"
                  aria-label="Lien vers Vibesite, agence web spécialisée dans les hébergements d'exception"
                  className="text-white/70 hover:text-white transition-colors duration-200 underline hover:no-underline focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#1C3A27] rounded-sm"
                >
                  Vibesite.fr
                </a>
                {" "}— Création de sites pour hébergements d'exception
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;